import React from 'react';
import { useLang } from '../contexts/LanguageContext';

const CONTACT_EMAIL = 'info@matbakhi.app';
const POLICY_URL = 'https://matbakhi.app';
const LAST_UPDATED = '2026-02-20';

export default function Privacy() {
  const { t, lang } = useLang();
  const content = lang === 'ar' ? AR_CONTENT : EN_CONTENT;

  return (
    <article className="prose prose-neutral dark:prose-invert max-w-3xl mx-auto space-y-6" data-testid="privacy-page">
      <h1 className="text-3xl sm:text-4xl font-display font-bold tracking-tight">
        {lang === 'ar' ? 'سياسة الخصوصية — مطبخي' : 'Privacy Policy — Matbakhi'}
      </h1>
      <p className="text-sm text-[#5C4D44] dark:text-neutral-400">
        {t('lastUpdated')}: {LAST_UPDATED} · <a href={POLICY_URL} className="underline">{POLICY_URL}</a>
      </p>
      {content.map((section) => (
        <section key={section.title}>
          <h2 className="text-xl font-display font-semibold mt-6 mb-2">{section.title}</h2>
          <p className="text-[#2C2420] dark:text-neutral-300 leading-relaxed whitespace-pre-line">{section.body}</p>
        </section>
      ))}
    </article>
  );
}

const AR_CONTENT = [
  { title: 'مقدمة',
    body: 'يحترم تطبيق مطبخي (Matbakhi) خصوصيتك. تشرح هذه السياسة كيف نجمع بياناتك ونستخدمها ونحميها عند استخدامك التطبيق على أجهزة أندرويد، iOS، أو عبر الويب. باستخدامك التطبيق فإنك توافق على هذه السياسة.' },

  { title: 'هوية مزوّد الخدمة',
    body: 'اسم التطبيق: مطبخي (Matbakhi)\nمعرّف الحزمة: com.matbakhi.app\nبريد التواصل: ' + CONTACT_EMAIL + '\nرابط هذه السياسة: ' + POLICY_URL },

  { title: 'اللغات المدعومة',
    body: 'يدعم التطبيق ست لغات لواجهة المستخدم والمحتوى: العربية، الإنجليزية، الفرنسية، الإسبانية، التركية، والأردية. يمكنك تغيير اللغة في أي وقت من قائمة اللغات.' },

  { title: 'البيانات التي نجمعها',
    body: 'عند تسجيل الدخول بحساب جوجل: اسمك، بريدك الإلكتروني، وصورة الملف الشخصي.\nمحتوى الحساب: الوصفات المفضّلة، قائمة التسوق، سجلّات السعرات، خطط الأسبوع، وأي وصفات تم تحويلها بالذكاء الاصطناعي.\nبيانات الاستخدام: عدد مشاهدات الوصفات وعمليات البحث (لتحسين التوصيات).\nالموقع التقريبي: نستخدم عنوان IP لتخمين دولتك (Geo-IP) لاقتراح خطة وجبات أسبوعية مناسبة لمنطقتك. لا نطلب موقعك الدقيق أبداً.\nرمز الإشعارات (FCM Token): معرّف مجهول الهوية للجهاز يُستخدم لإرسال الإشعارات إليك.' },

  { title: 'إشعارات Firebase Cloud Messaging (FCM)',
    body: 'يستخدم التطبيق خدمة Firebase Cloud Messaging من Google لإرسال إشعارات الدفع (مثل تذكيرات تسجيل السعرات، تنبيهات انتهاء التجربة المجانية، وإشعارات الوصفات الجديدة).\nالبيانات المرسلة لـ FCM: رمز الجهاز (FCM Token) ومعرّف المستخدم الداخلي فقط.\nيمكنك تعطيل الإشعارات في أي وقت من إعدادات نظام التشغيل في جهازك.\nلمزيد من المعلومات: https://firebase.google.com/support/privacy' },

  { title: 'إعلانات Google AdMob',
    body: 'قد يعرض التطبيق إعلانات عبر خدمة Google AdMob لدعم النسخة المجانية. تستخدم AdMob معرّف الإعلانات الخاص بجهازك (Android Advertising ID / IDFA على iOS) لعرض إعلانات أكثر ملاءمة.\nيمكنك إعادة تعيين أو تعطيل معرّف الإعلانات من إعدادات جهازك (إعدادات → جوجل → الإعلانات).\nالمشتركون في النسخة المدفوعة (Premium) لا يرون إعلانات.\nسياسة خصوصية AdMob: https://policies.google.com/technologies/ads' },

  { title: 'كيف نستخدم بياناتك',
    body: '- لتقديم خدمات التطبيق (حفظ المفضّلات، تتبّع السعرات، الخطط الأسبوعية).\n- لإرسال إشعارات متعلقة بحسابك (يمكنك تعطيلها).\n- لتحسين التوصيات وعرض اقتراحات مخصّصة عبر الذكاء الاصطناعي.\n- لعرض إعلانات ذات صلة (للمستخدمين المجانيين فقط).' },

  { title: 'الدفع والاشتراك (Stripe)',
    body: 'نستخدم Stripe لمعالجة مدفوعات الاشتراك المميّز (Matbakhi Premium). نحن لا نخزّن بيانات بطاقتك الائتمانية على خوادمنا.\nسياسة خصوصية Stripe: https://stripe.com/privacy' },

  { title: 'مشاركة البيانات مع أطراف ثالثة',
    body: 'لا نبيع بياناتك أبداً. نستخدم مزوّدي الخدمات التالين، ولكل منهم سياسة خصوصية مستقلة:\n• Google Sign-In (المصادقة)\n• Stripe (الدفع)\n• Google Gemini (الذكاء الاصطناعي للوصفات والترجمة)\n• OpenAI (تحويل النص إلى صوت لقارئ الوصفات)\n• Firebase Cloud Messaging (الإشعارات)\n• Google AdMob (الإعلانات للمستخدمين المجانيين)' },

  { title: 'الروابط التابعة (Affiliate)',
    body: 'يحتوي التطبيق على روابط لمنتجات أدوات الطبخ من Amazon, Noon, و AliExpress. عند شرائك من هذه الروابط قد نحصل على عمولة دون أي تكلفة إضافية عليك.' },

  { title: 'حقوقك (GDPR / CCPA / قوانين حماية البيانات)',
    body: 'يمكنك في أي وقت:\n- الوصول لبياناتك أو طلب نسخة منها.\n- تعديل أو حذف معلومات حسابك.\n- حذف حسابك بالكامل وكل البيانات المرتبطة به.\n- إلغاء اشتراكك المميّز.\n- إلغاء الاشتراك في إشعارات الدفع.\nللتواصل بشأن أي من هذه الحقوق، راسلنا على: ' + CONTACT_EMAIL },

  { title: 'الاحتفاظ بالبيانات',
    body: 'نحتفظ ببياناتك طوال فترة استخدامك للتطبيق. عند حذف حسابك، نحذف جميع البيانات المرتبطة به خلال 30 يوماً، باستثناء البيانات المطلوبة قانونياً للاحتفاظ بها (مثل سجلات الفواتير).' },

  { title: 'الأمان',
    body: 'نستخدم التشفير (HTTPS/TLS) لجميع الاتصالات. كلمات المرور لا تُخزَّن على خوادمنا لأننا نستخدم تسجيل الدخول الموحّد عبر جوجل. رموز الجلسات تُخزَّن في ملفات تعريف ارتباط آمنة (httpOnly).' },

  { title: 'الأطفال',
    body: 'التطبيق غير موجَّه للأطفال دون سن 13 عاماً، ولا نجمع بياناتهم عن قصد. إذا علمنا بجمع بيانات طفل دون 13 عاماً، سنحذفها فوراً.' },

  { title: 'تحديثات السياسة',
    body: 'قد نحدّث هذه السياسة من حين لآخر. سنُعلمك بأي تغييرات جوهرية داخل التطبيق أو عبر البريد الإلكتروني. تاريخ آخر تحديث مُبيَّن أعلى الصفحة.' },

  { title: 'تواصل معنا',
    body: 'لأي استفسار حول الخصوصية أو طلب حذف البيانات:\nبريد إلكتروني: ' + CONTACT_EMAIL + '\nعنوان السياسة العام: ' + POLICY_URL },
];

const EN_CONTENT = [
  { title: 'Introduction',
    body: 'Matbakhi ("we", "us") respects your privacy. This policy explains how we collect, use, and protect your data when you use our app on Android, iOS, or via the web. By using the app you agree to this policy.' },

  { title: 'Service Provider',
    body: 'App name: Matbakhi\nPackage ID: com.matbakhi.app\nContact email: ' + CONTACT_EMAIL + '\nPolicy URL: ' + POLICY_URL },

  { title: 'Supported Languages',
    body: 'Matbakhi supports six interface and content languages: Arabic, English, French, Spanish, Turkish, and Urdu. You can change the language at any time from the language menu.' },

  { title: 'Data we collect',
    body: 'When you sign in with Google: your name, email and profile picture.\nApp content: favorite recipes, shopping list, calorie logs, weekly plans, and any AI-converted recipes you save.\nUsage data: recipe view counts and search queries (to improve recommendations).\nApproximate location: we use your IP address to detect your country (Geo-IP) to suggest a region-appropriate weekly meal plan. We never request your precise location.\nNotification token: an anonymous device identifier (FCM token) used to deliver push notifications.' },

  { title: 'Firebase Cloud Messaging (FCM)',
    body: 'We use Google\'s Firebase Cloud Messaging to deliver push notifications (e.g. calorie-log reminders, free-trial expiry alerts, new recipe announcements).\nWhat is sent to FCM: only your device\'s FCM token and your internal user ID.\nYou can disable notifications at any time from your operating system\'s settings.\nMore info: https://firebase.google.com/support/privacy' },

  { title: 'Google AdMob Advertising',
    body: 'The app may display ads served by Google AdMob to support the free tier. AdMob uses your device\'s advertising identifier (Android Advertising ID / iOS IDFA) to show more relevant ads.\nYou can reset or disable the advertising identifier from your device settings (Settings → Google → Ads).\nPremium subscribers do not see ads.\nAdMob privacy policy: https://policies.google.com/technologies/ads' },

  { title: 'How we use your data',
    body: '- To provide app services (save favorites, calorie tracking, weekly plans).\n- To send account-related notifications (you can disable them).\n- To improve recommendations and personalised AI suggestions.\n- To show relevant ads (free users only).' },

  { title: 'Payments & subscription (Stripe)',
    body: 'We use Stripe to process Premium subscription payments. We never store credit-card details on our servers.\nStripe privacy policy: https://stripe.com/privacy' },

  { title: 'Third-party data sharing',
    body: 'We never sell your data. We rely on the following service providers, each with their own privacy policy:\n• Google Sign-In (authentication)\n• Stripe (payments)\n• Google Gemini (AI recipe suggestions & translation)\n• OpenAI (text-to-speech for the AI voice reader)\n• Firebase Cloud Messaging (push notifications)\n• Google AdMob (advertising for free users)' },

  { title: 'Affiliate links',
    body: 'The app contains affiliate links to kitchen-tool products from Amazon, Noon, and AliExpress. If you purchase via these links we may earn a commission at no extra cost to you.' },

  { title: 'Your rights (GDPR / CCPA / data-protection laws)',
    body: 'At any time you can:\n- Access your data or request a copy.\n- Edit or delete account information.\n- Delete your account and all associated data.\n- Cancel your Premium subscription.\n- Opt out of push notifications.\nTo exercise any of these rights, email: ' + CONTACT_EMAIL },

  { title: 'Data retention',
    body: 'We retain your data for as long as you use the app. When you delete your account, all associated data is deleted within 30 days, except for data we are legally required to retain (e.g. billing records).' },

  { title: 'Security',
    body: 'All communications use TLS/HTTPS encryption. We do not store passwords on our servers because we use Google single sign-on. Session tokens are stored in secure httpOnly cookies.' },

  { title: 'Children',
    body: 'The app is not directed at children under 13. We do not knowingly collect data from anyone under 13. If we learn that we have, we will delete it immediately.' },

  { title: 'Policy updates',
    body: 'We may update this policy from time to time. We will notify you of material changes inside the app or by email. The date of the last update is shown at the top of this page.' },

  { title: 'Contact us',
    body: 'For privacy questions or data-deletion requests:\nEmail: ' + CONTACT_EMAIL + '\nPublic policy URL: ' + POLICY_URL },
];
